/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class toothinformation extends IceEntity {
  tooth_information_key: string = "";
  code_list_qualifier_code: string = "";
  tooth_code: string = "";
  tooth_surface1: string = "";
  tooth_surface2: string = "";
  tooth_surface3: string = "";
  tooth_surface4: string = "";
  tooth_surface5: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "TOOTH_INFORMATION";
  }
}
